/**
 * @fileoverview Agent definition for world-system-details-generator-v3.
 *
 * @category world-building.systems.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-system-details-generator-v3',
  kind: 'primitive',
  name: 'World System Details Generator',
  description: 'Generates complete details for a world system based on a selected creative direction.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.systems.details',
    usedBy: ['use-world-system-details-generator-v3.ts'],
    usedInComposites: [],
    relatedAgents: [
      'world-system-details-ideation-v3',
      'world-system-snapshotter-v3',
    ],
  },
};
